import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'
import { PageLoader } from '@/components/PageLoader'

interface AdminRouteProps {
  children: React.ReactNode
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return <PageLoader />
  }

  if (!user) {
    const returnPath = location.pathname + location.search;
    return <Navigate to={`/login?from=${encodeURIComponent(returnPath)}`} replace />
  }

  if (!user.is_superuser) {
    return <Navigate to="/" state={{ from: location, error: 'Admin access required' }} replace />
  }

  return <>{children}</>
}
